import React from 'react';
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import { OrderType } from 'models/order.model';
import Tippy from '@tippyjs/react';
import { InfoIcon } from 'cokitchen-icons';

type Props = {
  order: OrderType;
};

const CSLiveTripCardFooter = ({ order }: Props) => {
  const createdDateObj = new Date(order?.created_at ?? '');
  const createdTime = createdDateObj.toLocaleString('en-NG', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  const completedDateObj = new Date(order?.kitchen_dispatched_time ?? '');
  const completedTime = completedDateObj.toLocaleString('en-NG', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  const cancelledDateObj = new Date(order?.cancelled_time ?? '');
  const cancelledTime = cancelledDateObj.toLocaleString('en-NG', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  return (
    <div className='border-t border-gray-border py-2  flex justify-between items-center px-3'>
      <p className='flex text-gray-5 font-medium uppercase min-w-fit items-center gap-2 text-xs tracking-wider'>
        <ClockIcon className='w-4 h-4 text-gray-5' />
        {createdTime}
      </p>

      <Tippy
        content={
          <div className=' p-2 px-3 rounded-md shadow-md bg-white text-gray-8 font-medium text-xs'>
            Dispatch time
          </div>
        }>
        <div className='flex items-center gap-2 p-1 px-3 rounded-[2px] bg-gray-11 border border-[#EFEEEC] text-gray-5 text-xs'>
          {order?.kitchen_dispatched_time ? (
            <>
              <InfoIcon />
              {completedTime}
            </>
          ) : (
            'Yet to be dispatched'
          )}
        </div>
      </Tippy>

      {order?.cancelled_time ? (
        <>
          <InfoIcon />
          {cancelledTime}
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default CSLiveTripCardFooter;
